import { normalizeEmail, normalizePhone } from './normalize'

function hasSubtleCrypto (): boolean {
  return typeof globalThis.crypto?.subtle?.digest === 'function'
}

function toHex (buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map(byte => byte.toString(16).padStart(2, '0'))
    .join('')
}

/**
 * SHA-256 of `value`, lowercase hex. Fails closed (`null`) on empty input or when
 * `crypto.subtle` is unavailable (e.g. non-secure context) — analytics must never throw.
 */
export async function sha256Hex (value: string): Promise<string | null> {
  if (!value || !hasSubtleCrypto()) {
    return null
  }

  try {
    const encoded = new TextEncoder().encode(value)
    const digest = await globalThis.crypto.subtle.digest('SHA-256', encoded)

    return toHex(digest)
  } catch {
    return null
  }
}

export async function hashedEmail (email: string | null | undefined): Promise<string | null> {
  return sha256Hex(normalizeEmail(email))
}

export async function hashedPhone (phone: string | null | undefined): Promise<string | null> {
  return sha256Hex(normalizePhone(phone))
}
